import styled, { css, StyledComponent } from 'styled-components';
import { Select as AntSelect, SelectProps } from 'antd';
export const MetaDataBoxContainer = styled.div`
  .metadata-header {
    border-bottom: 1px solid #d9d9d9;
    background: #e9e9e9;
    height: 44px;
    padding: 8px;
    font-size: 14px;
    display: flex;
    box-sizing: border-box;
    align-items: center;
    &:hover {
      .delete-icon {
        > button {
          display: inline-block;
        }
      }
    }
  }
  .and-tag {
    border-radius: 16px;
    background: var(--Fill-BgBase, #f5f5f5);
    color: var(--Text-TextPrimary, rgba(0, 0, 0, 0.88));
    display: flex;
    padding: 0 8px;
    align-items: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    height: 20px;
    letter-spacing: -0.12px;
    margin-right: 12px;
  }
  .select-wapper {
    margin-left: 8px;
    flex: 1;
  }
  .delete-icon {
    text-align: right;
    min-width: 40px;
    opacity: 0.45;
    /* //display: inline-block; */
    > button {
      display: none;
    }
  }
  .add-rule {
    padding: 10px 0;
    margin: 0 8px 0 82px;
    display: flex;
    line-height: 20px;
    span {
      color: #0046ff;
      margin-right: 22px;
      cursor: pointer;
    }
  }
`;

export const CusSelect = styled(AntSelect)`
  &&.emp-ant-select {
    width: 100%;
    min-width: 150px;
    color: rgba(0, 0, 0, 0.85);

    .emp-ant-select-selector {
      width: 100%;
      height: 28px;
      border-radius: 3px;
      border: solid 1px #bfbfbf;
      background-color: #fff;

      &:hover {
        border: solid 1px rgba(0, 0, 0, 0.15);
      }

      .emp-ant-select-selection-item {
        letter-spacing: -0.01em;
        line-height: 26px;
      }
    }

    .emp-ant-select-clear {
      background: transparent !important;
    }

    .emp-ant-select-selection-placeholder {
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
    }
  }

  &&.emp-ant-select-disabled.emp-ant-select:not(.emp-ant-select-customize-input)
    .emp-ant-select-selector {
    color: rgba(0, 0, 0, 0.88);
  }
`;
